import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import { AppContext } from '@/contexts/AppContext';
import { getHttpResponse } from '@/api/helper';
/** @typedef {import("@/types/UserInfo").UserInfo} UserInfo */
const useGetUserInfoQuery = () => {
  const { userId, token, providerId } = useContext(AppContext);
   /** @type {()=>Promise<import("axios").AxiosResponse<UserInfo,any>>} */
  const fetchFn = () =>{
    return getHttpResponse(`/user-configuration-service/provider/${providerId}/users/${userId}`, token, userId)
  }

 
  return useQuery({
    queryKey: ['userInfo', userId],
    staleTime: 300,
    refetchOnWindowFocus:false,
    queryFn: fetchFn
  });
};

export default useGetUserInfoQuery;
